import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { Sucursal } from '../models/Sucursal';

export class SucursalService {
  
  static async getAllSu() {
    try {
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.SUCURSAL);
      
      let Data;
      if (response.data.success && response.data.data) {
        Data = response.data.data;
      } else if (Array.isArray(response.data)) {
        Data = response.data;
      } else {
        throw new Error('Formato de datos incorrecto del servidor');
      }
      
      if (!Array.isArray(Data)) {
        throw new Error('Los datos recibidos no son un array');
      }
      
      const mapped = Data.map((rData) => new Sucursal(rData));
      return mapped;
      
    } catch (error) {
      console.error('❌ Error al obtener Sucursales:', error);
      throw new Error('Error al obtener Sucursales: ' + error.message);
    }
  }

  static async getSucursalesByEmpresa(empresaId) {
    try {
      console.log('🏢 Obteniendo sucursales de empresa:', empresaId);
      
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.SUCURSAL}/empresa/${empresaId}`);
      
      let Data;
      if (response.data.success && response.data.data) {
        Data = response.data.data;
      } else if (Array.isArray(response.data)) {
        Data = response.data;
      } else {
        throw new Error('Formato de datos incorrecto del servidor');
      }
      
      if (!Array.isArray(Data)) {
        throw new Error('Los datos recibidos no son un array');
      }
      
      const mapped = Data.map((sucData) => new Sucursal(sucData));
      return mapped;
      
    } catch (error) {
      console.error('❌ Error al obtener sucursales de la empresa:', error);
      throw new Error(`Error al obtener sucursales de la empresa ${empresaId}: ` + error.message);
    }
  }

  static async getById(id) {
    try {
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.SUCURSAL}/${id}`);
      const rData = response.data.data || response.data;
      return new Sucursal(rData);
    } catch (error) {
      console.error('❌ Error obteniendo Sucursal:', error);
      throw new Error('Error al obtener el Sucursal');
    }
  }

  // ✅ CREAR SUCURSAL - IGUAL QUE PRODUCTOS
  static async create(Data) {
    try {
      console.log('🔍 === CREATE SUCURSAL DEBUG ===');
      console.log('🔍 Data recibido:', Data);
      
      let sucursal;
      if (Data instanceof Sucursal) {
        sucursal = Data;
      } else {
        sucursal = new Sucursal(Data);
      }
      
      console.log('🔍 Sucursal instance:', sucursal.toDebug());
      
      // ✅ USAR FORMDATA
      const formData = new FormData();
      const basicData = sucursal.getBasicData();
      
      // Agregar campos básicos (sin id_sucursal para crear)
      Object.keys(basicData).forEach(key => {
        if (key !== 'id_sucursal') {
          formData.append(key, basicData[key]);
        }
      });
      
      // ✅ MANEJAR LOGO
      if (sucursal.Logo && sucursal.Logo.length > 0) {
        console.log('📷 Agregando logo - tamaño base64:', sucursal.Logo.length);
        
        try {
          const base64Data = sucursal.Logo.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          formData.append('logoFile', blob, 'logo.jpg');
          console.log('✅ Logo agregado al FormData');
        } catch (error) {
          console.error('❌ Error procesando logo:', error);
          throw new Error('Error al procesar el logo');
        }
      }
      
      // ✅ MANEJAR BANNER
      if (sucursal.Banner && sucursal.Banner.length > 0) {
        console.log('🖼️ Agregando banner - tamaño base64:', sucursal.Banner.length);
        
        try {
          const base64Data = sucursal.Banner.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          formData.append('bannerFile', blob, 'banner.jpg');
          console.log('✅ Banner agregado al FormData');
        } catch (error) {
          console.error('❌ Error procesando banner:', error);
          throw new Error('Error al procesar el banner');
        }
      }
      
      // Debug FormData
      console.log('🔍 === FormData FINAL para CREATE ===');
      for (let pair of formData.entries()) {
        const value = pair[1] instanceof Blob ? `[BLOB: ${pair[1].size} bytes]` : pair[1];
        console.log(`  ${pair[0]}: ${value}`);
      }
      
      const response = await apiClient.post(
        API_CONFIG.ENDPOINTS.SUCURSAL,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      console.log('✅ Sucursal creado:', response.data);
      
      const createdData = response.data.data || response.data;
      return new Sucursal(createdData);
    } catch (error) {
      console.error('❌ Error creando Sucursal:', error);
      throw new Error('Error al crear el Sucursal: ' + (error.response?.data?.message || error.message));
    }
  }

  // ✅ ACTUALIZAR SUCURSAL - IGUAL QUE PRODUCTOS
  static async update(id, Data) {
    try {
      console.log('🔍 === UPDATE SUCURSAL DEBUG ===');
      console.log('🔍 ID:', id);
      
      if (!id) {
        throw new Error('ID de Sucursal no proporcionado');
      }
      
      let sucursal;
      if (Data instanceof Sucursal) {
        sucursal = Data;
      } else {
        sucursal = new Sucursal(Data);
      }
      
      console.log('🔍 Sucursal a actualizar:', sucursal.toDebug());
      
      // ✅ USAR FORMDATA
      const formData = new FormData();
      const basicData = sucursal.getBasicData();
      
      // Agregar campos básicos (incluyendo id_sucursal)
      formData.append('id_sucursal', id);
      Object.keys(basicData).forEach(key => {
        if (key !== 'id_sucursal') {
          formData.append(key, basicData[key]);
        }
      });
      
      // ✅ MANEJAR LOGO
      if (sucursal.Logo && sucursal.Logo.length > 0) {
        console.log('📷 Actualizando logo - tamaño base64:', sucursal.Logo.length);
        
        try {
          const base64Data = sucursal.Logo.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          formData.append('logoFile', blob, 'logo.jpg');
          console.log('✅ Logo agregado al FormData');
        } catch (error) {
          console.error('❌ Error procesando logo:', error);
          throw new Error('Error al procesar el logo');
        }
      }
      
      // ✅ MANEJAR BANNER
      if (sucursal.Banner && sucursal.Banner.length > 0) {
        console.log('🖼️ Actualizando banner - tamaño base64:', sucursal.Banner.length);
        
        try {
          const base64Data = sucursal.Banner.replace(/^data:image\/[^;]+;base64,/, '');
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/jpeg' });
          
          formData.append('bannerFile', blob, 'banner.jpg');
          console.log('✅ Banner agregado al FormData');
        } catch (error) {
          console.error('❌ Error procesando banner:', error);
          throw new Error('Error al procesar el banner');
        }
      }
      
      // Debug FormData
      console.log('🔍 === FormData FINAL para UPDATE ===');
      for (let pair of formData.entries()) {
        const value = pair[1] instanceof Blob ? `[BLOB: ${pair[1].size} bytes]` : pair[1];
        console.log(`  ${pair[0]}: ${value}`);
      }
      
      const response = await apiClient.put(
        `${API_CONFIG.ENDPOINTS.SUCURSAL}/${id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      
      console.log('✅ Sucursal actualizado:', response.data);
      
      const updatedData = response.data.data || response.data;
      return new Sucursal(updatedData);
      
    } catch (error) {
      console.error('❌ Error actualizando Sucursal:', error);
      throw new Error('Error al actualizar el Sucursal: ' + (error.response?.data?.message || error.message));
    }
  }

  static async deleteRole(id) {
    try {
      await apiClient.delete(`${API_CONFIG.ENDPOINTS.SUCURSAL}/${id}`);
      return true;
    } catch (error) {
      console.error('❌ Error eliminando sucursal:', error);
      throw new Error('Error al eliminar el sucursal');
    }
  }

  static async testConnection() {
    try {
      console.log('🧪 === TEST CONNECTION ===');
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.SUCURSAL);
      console.log('✅ ¡CONEXIÓN EXITOSA!');
      return response;
    } catch (error) {
      console.error('❌ FALLO EN LA CONEXIÓN:', error);
      return error;
    }
  }
}